import { Inject, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../shared/service/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.getWithExpiry()) {
    // this.store.dispatch(new AuthActions.Set({ expiry: 0, login: false }));
    router.navigate(['/']);

    return false;
  }

  return true;
};
